/**
 * The one reader for `transmissions.tags`.
 *
 * The column is text and holds two formats: a JSON array string (every current
 * writer uses JSON.stringify — 107 of 149 rows on 2026-09-25) and an older
 * comma-separated form ("Science Fiction, Hard SF" — 25 rows). Six call sites
 * each hand-wrote their own reader and each picked one format: ShareBook split
 * on commas and showed `["Science Fiction"` as a chip; ReadingInsights called
 * JSON.parse unguarded and threw on the comma rows, killing the whole page.
 *
 * Do NOT normalise the column instead — the iOS app reads `transmissions`.
 * Tolerate both formats here, in one place.
 */
export function parseTags(raw: unknown): string[] {
  if (Array.isArray(raw)) return raw.map(String).map(t => t.trim()).filter(Boolean);
  if (typeof raw !== 'string') return [];
  const s = raw.trim();
  if (!s || s === '[]') return [];
  if (s.startsWith('[')) {
    try {
      const parsed = JSON.parse(s);
      if (Array.isArray(parsed)) return parsed.map(String).map(t => t.trim()).filter(Boolean);
    } catch {
      // Malformed JSON — fall through to the comma reader.
    }
  }
  return s.split(',').map(t => t.trim().replace(/^[["']+|[\]"']+$/g, '').trim()).filter(Boolean);
}
